import { createContext } from 'react';
import {
  IAssembleiaAssociadoEvento,
} from 'store/modules/AssembleiasAssociadoReducer';
import { ThunkDownloadDocumentReturn, ThunkLoadDuvidasReturn } from 'store/modules/AssembleiasAssociadoActions';

export type AssembleiaAssociadoActionsDownloadDocument = (
  idDocumento: number,
  nome: string
) => ThunkDownloadDocumentReturn;

export type AssembleiaAssociadoActionsLoadDuvidas = (
  idEvento: number,
  cpf: string,
) => ThunkLoadDuvidasReturn;

interface AssembleiaAssociadoContext {
  cpf?: string;
  currentEvent: IAssembleiaAssociadoEvento | null;
  assembleiaAssociadoActionsDownloadDocument: AssembleiaAssociadoActionsDownloadDocument;
  assembleiaAssociadoActionsLoadDuvidas: AssembleiaAssociadoActionsLoadDuvidas;
}

export default createContext<AssembleiaAssociadoContext>({
  currentEvent: null,
  assembleiaAssociadoActionsDownloadDocument: () => () => Promise.resolve(),
  assembleiaAssociadoActionsLoadDuvidas: () => () => Promise.resolve(),
});
